import React from 'react';
import './LeadgenLoading.css';

/**
 * Leadgen Consolidated Loading Component
 * - Large / Full-Page Loading (fullPage = true): Uses the Brand Logo Spinner (Spinner 2).
 * - Small / Inline Component Loading (fullPage = false): Uses the Compact Blue Spinner (Spinner 1).
 */
const Loading = ({ message = 'Loading...', fullPage = false, showSpinner = true }) => {
  if (fullPage) {
    return (
      <div className="tm-loading-container full-page">
        <div className="tm-brand-spinner-wrapper">
          {showSpinner && (
            <div className="tm-brand-logo-spin-wrap">
              <img src="/image/side_logo.png" alt="Loading Logo" className="tm-brand-logo-spin" />
            </div>
          )}
          <span className="tm-brand-loading-text">{message}</span>
        </div>
      </div>
    );
  }

  return (
    <div className="tm-loading-container">
      {showSpinner && <div className="tm-loading-spinner" />}
      <span className="tm-loading-text">{message}</span>
    </div>
  );
};

export default Loading;
